var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("style",{"id":"style4202","type":"text/css","key":0},"\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n"),React.createElement("path",{"style":{"clipRule":"evenodd","fillRule":"evenodd"},"id":"path4204","d":"m 9.7,20 2,-2.1 L 4,10 11.7,2.1 9.7,0 2,7.9 0,10 2,12.1 9.7,20 Z","className":"st0","key":1})]);
}

ArrowLeft.defaultProps = {"height":"20","width":"11.7","viewBox":"0 0 11.7 20","y":"0px","x":"0px","id":"Layer_1","version":"1.1"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
